module.exports = __webpack_public_path__ + "img/title@2x.dea3a0d5.png";